module.exports = __webpack_public_path__ + "img/tpo-yellowcat.70a19b2c.jpg";